import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=e5058754&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.scss?vue&type=style&index=0&id=e5058754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5058754",
  null
  
)

export default component.exports